import { useState } from 'react'
import { Box } from '@mui/material'
import { Search20Regular } from '@/components/Icon'
import NavSectionHeader from './NavSectionHeader'
import NavSectionHeaderAction from './NavSectionHeaderAction'
import ThreadsSectionAllThreadsDialog from './ThreadsSectionAllThreadsDialog'
import { HomeNavThreadList } from './HomeNavThreadList'
import styles from './HomeNavThreadList.module.scss'

export default function HomeNavProjectsSection({ projects, allProjects, selectedProjectId, onSelectProject, onRenameProject }) {
  const [searchDialogOpen, setSearchDialogOpen] = useState(false)
  const searchableProjects = allProjects ?? projects

  return (
    <Box className={styles.chatsSection}>
      <NavSectionHeader
        title="Project List"
        actions={
          <NavSectionHeaderAction
            Icon={Search20Regular}
            label="Search projects"
            onClick={() => setSearchDialogOpen(true)}
          />
        }
      />
      <Box className={styles.chatsBody}>
        <HomeNavThreadList
          threads={projects}
          selectedThreadId={selectedProjectId}
          onSelectThread={onSelectProject}
          onRenameThread={onRenameProject}
          showChatIcon={false}
          scrollable
          ariaLabel="Project list"
        />
      </Box>
      <ThreadsSectionAllThreadsDialog
        open={searchDialogOpen}
        onClose={() => setSearchDialogOpen(false)}
        threads={searchableProjects}
        selectedThreadId={selectedProjectId}
        onSelectThread={onSelectProject}
      />
    </Box>
  )
}
